import { combineReducers } from "redux";
import tabs from "./tabs";
import flows from "./flows";
import settings from "./settings";
import cxfComponents from "./cxfComponents";
import flowExecution from "./flowExecution";
import calendar from "./calendar";
import componentGroups from "./componentGroups";
import componentPropsPanel from "./componentPropsPanel";
import users from "./users";
import common from "./common";
import editorContext from "./editorContext";
import tenant from "./tenant";
import triggers from "./triggers";

const designerReducer = combineReducers({
  tabs,
  flows,
  settings,
  cxfComponents,
  flowExecution,
  calendar,
  componentGroups,
  componentPropsPanel,
  users,
  common,
  editorContext,
  tenant,
  triggers,
});

export default designerReducer;
